export const NO_LOGGED_ERROR_MESSAGE = "nie jest zalogowany";

export const UNKNOWN_ERROR = "Wystąpił nieznany błąd";

const EXCLUDED_ERROR_MESSAGES = [
  NO_LOGGED_ERROR_MESSAGE,
  "Twój koszyk jest pusty - dodaj najpierw bilety aby móc skorzystać z promocji.",
  "Brak aktywnej sesji użytkownika",
  "404 ",
  "Brak danych",
  "Index: 0",
  "HTTP Status 404",
  "Apache Tomcat",
  "on GET request for",
  "The requested resource",
];

const DEV_MESSAGE_PATTERNS = [
  /Can not instantiate/i,
  /\[simple type, class /,
  /at \[Source:/,
  /com\.\w+\.\w+\.\w+/,
  /\n\s*at /,
  /java\.(lang|util|io|net)\./,
  /org\.\w+\.\w+\.\w+/,
  /StatementCallback/i,
  /bad SQL grammar/i,
  /SQLSyntaxErrorException/i,
  /<!doctype html>/i,
  /HTTP Status \d+/i,
];

const isDevMessage = (msg: string): boolean => DEV_MESSAGE_PATTERNS.some((pattern) => pattern.test(msg));

const isExcludedMessage = (msg: string): boolean => {
  const lower = msg.toLowerCase();
  return EXCLUDED_ERROR_MESSAGES.some((excludedMsg) => lower.includes(excludedMsg.toLowerCase()));
};

export const filterApiErrorMessages = (errors: string[] | null | undefined): string[] => {
  if (!errors || errors.length === 0) {
    return [];
  }

  return errors.filter((item) => {
    if (typeof item !== "string") {
      return false;
    }
    const trimmed = item.trim();
    if (!trimmed || trimmed === "null") {
      return false;
    }
    if (isDevMessage(item)) {
      return false;
    }
    if (isExcludedMessage(item)) {
      return false;
    }
    return true;
  });
};

export const toUserErrorMessage = (errors: string[] | null | undefined, fallback: string = UNKNOWN_ERROR): string => {
  const list = (errors ?? []).filter((item): item is string => typeof item === "string" && item.trim() !== "" && item !== "null");
  if (list.length === 0) {
    return "";
  }

  const filtered = filterApiErrorMessages(list);
  if (filtered.length > 0) {
    return filtered[0];
  }

  const hasExcluded = list.some(isExcludedMessage);
  if (hasExcluded) {
    return "";
  }

  return fallback;
};

export const logApiError = (method: string, url: string, payload: { errorTable?: string[]; messageType?: string } | null | undefined) => {
  if (!payload) {
    return;
  }
  console.error("[API error]", method, url, payload.errorTable, payload.messageType);
};

export const errorMessageFromApi = (
  response: { isError?: boolean; errorTable?: string[] } | null | undefined,
  fallback: string = UNKNOWN_ERROR
): string => {
  if (!response?.isError) {
    return "";
  }
  return toUserErrorMessage(response.errorTable, fallback);
};

export const errorMessageFromThunkAction = (action: { payload?: { isError?: boolean; errorTable?: string[] } } | null | undefined): string => {
  return errorMessageFromApi(action?.payload);
};
